import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckboxRoundIndeterminateIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="#2196F3" />
            <line
                x1="5.85"
                y1="11.75"
                x2="18.15"
                y2="11.75"
                stroke="white"
                fill="none"
                strokeWidth="1.7"
                strokeLinecap="round"
            />
        </SvgIcon>
    );
};
